import React from 'react'

import fiftyPercentImg from '@kolayyolla/common/images/fifty-percent.png'
import locationImg from '@kolayyolla/common/images/location.png'
import mealsImg from '@kolayyolla/common/images/meals.png'
import payImg from '@kolayyolla/common/images/pay.png'

import { Container, Grid, Typography } from '@mui/material'
import { yellow } from '@mui/material/colors'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  container: {
    background: 'linear-gradient(180deg, rgba(255,206,103,0.22) -42.47%, rgba(253,237,202,0) 100%)',
    paddingTop: theme.spacing(2)
  },
  header: {
    color: yellow[900],
    fontWeight: 'bold'
  },

  img: {
    height: 112,
    marginBottom: theme.spacing(2),
    filter: 'drop-shadow(5px 5px 5px rgba(255,179,14,0.3))'
  },
  gridItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    textAlign: 'center',
    padding: theme.spacing(2, 0)
  }
}))

export default function HowItWorks () {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <Typography variant="h3" align="center" className={classes.header}>Nasıl Çalışıyor?</Typography>
      <Container>
        <Grid container spacing={8} mt={0}>
        <Grid xl={3} lg={3} md={6} xs={12} item className={classes.gridItem}>
          <img src={locationImg} className={classes.img} />
          <Typography variant="h6" gutterBottom component="div">
            Restoranını seç
          </Typography>
          <Typography variant="body1" gutterBottom component="div">
            Beğendin restoranda sepetini oluştur. Siparişini ver ve sipariş serüvenine başla.
          </Typography>
        </Grid>

        <Grid xl={3} lg={3} md={6} xs={12} item className={classes.gridItem}>
        <img src={fiftyPercentImg} className={classes.img} />
          <Typography variant="h6" gutterBottom component="div">
            %50 KumPara Kazan
          </Typography>
          <Typography variant="body1" gutterBottom component="div">
            Her Restoran için o restorana özel ilk siparişte <strong>%50</strong> hoşgeldin kumParası kazan. İlk siparişlerde sepet tutarı ne kadar yüksekse o kadar kumPara kazanabilirsin.
          </Typography>
        </Grid>

        <Grid xl={3} lg={3} md={6} xs={12} item className={classes.gridItem}>
        <img src={payImg} className={classes.img} />
          <Typography variant="h6" gutterBottom component="div">
            Ödemeni yap
          </Typography>
          <Typography variant="body1" gutterBottom component="div">
            Kredi kartı, nakit yada online ödeme seçeneklerinden birini kullan, kazandığın kumParayı aynı restoranda sonraki siparişlerinde harca.
          </Typography>
        </Grid>

        <Grid xl={3} lg={3} md={6} xs={12} item className={classes.gridItem}>
        <img src={mealsImg} className={classes.img} />
          <Typography variant="h6" gutterBottom component="div">
            Tekrar Biriktir, Tekrar Harca
          </Typography>
          <Typography variant="body1" gutterBottom component="div">
            Sonraki kumPara kullanmadığın her siparişte biriktirmeye devam et, kazandığın kumParaları tekrar harca.
          </Typography>
        </Grid>
        </Grid>
      </Container>

    </div>
  )
}
